import React from "react";

export const Pluto = () => {
  return (
    <div>
      <div
        id={"pluto"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};
